import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import CommissionServices from "@/pages/CommissionServices";
import Workforce from "@/pages/Workforce";
import Transport from "@/pages/Transport";
import ArrsSupport from "@/pages/ArrsSupport";
import International from "@/pages/International";
import OutOfHours from "@/pages/OutOfHours";
import CommunityPharmacy from "@/pages/CommunityPharmacy";
import NcsClinic from "@/pages/NcsClinic";
import Careers from "@/pages/Careers";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CaseStudy from "@/pages/CaseStudy";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#FBFBFA]">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollManager />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/commission-clinical-services" element={<CommissionServices />} />
            <Route path="/request-clinical-workforce" element={<Workforce />} />
            <Route path="/transport" element={<Transport />} />
          <Route path="/arrs-nhs-support" element={<ArrsSupport />} />
            <Route path="/international" element={<International />} />
            <Route path="/out-of-hours" element={<OutOfHours />} />
            <Route path="/community-pharmacy" element={<CommunityPharmacy />} />
            <Route path="/ncs-clinic" element={<NcsClinic />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/case-study" element={<CaseStudy />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
